import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import AuthUtility from './auth/AuthUtility';
import LoadingSpinner from './LoadingSpinner';
import { readAlbum } from '../utils/AlbumService';
import { useAudio } from "../../context/AudioProvider";
import { useOffCanvas } from '../../context/OffCanvasProvider';
import TrackList from "./TrackList";
import FeatureOptionsPanel from '../panels/FeatureOptionsPanel';
import { trackActivity } from '../utils/ActivityTracker';

import swal from 'sweetalert';

const error_style = 'font-source-sans font-small font-weight-500 txt-000 bg-light-red p-5';

function Album() {

	const navHistory = useNavigate();
	const location = useLocation();

	// get URL parameters
	const { random_id, type } = useParams();

	const {
		tracklist: globalTracklist,
		loadTracklist,
		clearTracklist,
		currentIndex,
		isPlaying,
		isPaused,
		playTrack,
		pause,
		resume
	} = useAudio();

	// using hooks
	const [isLoading, setIsLoading] = useState(false);
	const [isMounted, setIsMounted] = useState(false);
	const [viewMode, setViewMode] = useState('none'); // 'none' | 'view_album' | 'view_liked_tracks'
	const [album, setAlbum] = useState(null);
	const [authRole, setAuthRole] = useState(
		AuthUtility.isLoggedIn() ? localStorage.getItem('auth_role') : null
	);

	const { push: openCanvas } = useOffCanvas();  // ✅ load offcanvas functions

	// Initial call for user list items
	useEffect(() => {

		setIsLoading(true);

		if (isMounted) {
			console.log('[Album - useEffect] mounted');

			readAlbum(random_id, type, setViewMode, setIsLoading, setAlbum, navHistory, swal);

			console.log(location.pathname);

			var locationSplit = location.pathname.split("/");
			if (locationSplit[3] === 'playlist') {
				localStorage.setItem('user_playlist', locationSplit[2]);
				if (locationSplit[2] === 'meghnas_playlist') {
					localStorage.setItem('ajax_flag', 'm-action');
				}
			}
		} else {
			setIsMounted(true);
		}

	}, [isMounted, random_id, type, location, navHistory]);

	// Load into global audio provider if it's a new album
	useEffect(() => {
		if (!album) return;

		const isSameAlbum =
			globalTracklist &&
			globalTracklist.random_id === album.random_id &&
			globalTracklist.type === album.type;

		if (!isSameAlbum) {
			// Different album => load into AudioProvider
			clearTracklist();
			loadTracklist(album, { startIndex: 0, autoPlay: false });

			if (localStorage.getItem('ajax_flag') === 'm-action') {
				trackActivity({
					objectEvent: 'LOAD_ALBUM',
					objectType: 'album',
					objectTitle: album.title,
				});
			}
		}
	}, [album]);

	// Keep album in sync when viewing Liked Songs
	useEffect(() => {
		if (!album) return;

		// Only sync when viewing liked songs
		if (album.type === "liked" && globalTracklist) {

			// If the list of tracks changed, reassign album
			if (JSON.stringify(album.tracks) !== JSON.stringify(globalTracklist.tracks)) {
				setAlbum(prev => ({
					...prev,
					tracks: globalTracklist.tracks
				}));
			}
		}
	}, [globalTracklist, album]);


	function openOptions(e) {
		e.stopPropagation();

		openCanvas({
			component: FeatureOptionsPanel,
			props: {
				track: null,
				tracklist: album,
			}
		});
	}

	return (
		<div className={`body-content bg-fff pt-70l-110m-50s ${authRole === null || authRole === '' ? 'pb-160l-125s' : 'pb-220l-180s'}`}>

			<div className="panel large">
				<div className="grid-x">
					<div className="large-12 medium-12 small-12 cell text-center pt-20l-10s">
						{isLoading &&
							<>
								<LoadingSpinner paddingclassName="pt-20" sizeclassName="none" />
								<div className="font-poppins font-size-18l-16m font-weight-400 text-center pt-20l-10s">Loading {type}...</div>
							</>
						}

						{!isLoading && (viewMode === "view_album" || viewMode === 'view_liked_tracks') && album ? (
							<div className="albumX">
								<div className="horizontal-container justify-left pl-20X pb-5">
									<span className="">
										<span className="font-orbitron font-size-22l-20m-17s font-weight-800 letter-spacing-0px uppercase italic">{album.title}</span>
									</span>
									{album.type === 'demos' && (
										<span className="pl-5">
											<span className="font-poppins font-size-14 font-weight-400 letter-spacing-0px italic">(Demos)</span>
										</span>
									)}
									<span className="align-right">
										<div className="horizontal-container justify-right">
											<button className="track-button-transparent options" onClick={(e) => openOptions(e)}>
												<span></span>
												<span></span>
												<span></span>
											</button>
										</div>
									</span>
								</div>

								<TrackList
									album={album}
									currentIndex={currentIndex}
									isPlaying={isPlaying}
									isPaused={isPaused}
									onPlayTrack={(idx) => {
										playTrack(idx);
									}}
									onPauseTrack={pause}
									onResumeTrack={resume}
								/>
							</div>
						) : (
							!isLoading && <div className="font-poppins font-size-18l-16m font-weight-400 text-center">No album data found.</div>
						)}
					</div>
				</div>
			</div>

		</div>
	);
}

export default Album;